export const NON_DIGITS_GLOBAL = /\D/g;
